
const styles = {
    card: {
        marginBottom: '50px',
        backgroundColor: 'transparent',
        backgroundColor: '#fff',
        borderRadius: '0px 25px 0px 25px',
        boxShadow: "rgb(0 0 0) 1px 1px 20px -10px",
    },
    cardImg: {
        maxWidth: "150px",
        height: '150px',
        margin: '0 auto',
        backgroundColor: 'tranparent',
    },
    cardHead: {
        color: '#469ff5', textTransform: 'uppercase', margin: '15px 0', fontSize: '22px', letterSpacing: '1px',
    },
    cardPara: {
        color: 'gray',
        fontSize: '16px',
        letterSpacing: '1px',
    },
    cardLink: {
        color: 'gray',
    }
}

export default styles;